import BufferLoader from './BufferLoader.js'
import md5 from './md5.js'

let audioContext = new AudioContext()
let songId = null
let buffers = []
let sources = []
let gainNodes = {}
let volume = 0
let systemVolume = 0
const hardVolume = 0.33
let guide = false

function load(newSongId, cb) {
	stop()
	if (newSongId === songId) {
		if (cb) cb()
		return
	}
	songId = newSongId
	let folder = md5(songId+'_folder')
	let musicFile = md5(songId+'_musicFile')
	let guideFile = md5(songId+'_guideFile')
	let files = [
		'/songs/'+folder+'/'+musicFile,
		'/songs/'+folder+'/'+guideFile
	]
	let bufferLoader = new BufferLoader(audioContext, files, function(newBuffers) {
		buffers = newBuffers
		if (cb) cb()
	})
	bufferLoader.load()
}

function play(newSongId, newPosition) {
	stop()
	if (newSongId !== songId) {
		let t1 = Date.now()
		load(newSongId, function() {
			let t2 = Date.now()
			let offset = (t2-t1)/1000
			play(newSongId, newPosition+offset)
		})
		return
	}
	for (let [i, buffer] of buffers.entries()) {
		let source = audioContext.createBufferSource()
		source.buffer = buffer
		let gainNode = audioContext.createGain()
		source.connect(gainNode)
		gainNode.connect(audioContext.destination)
		if (i === 0) gainNodes.music = gainNode
		else if (i === 1) gainNodes.guide = gainNode
		sources.push(source)
		source.start(0, newPosition)
	}
	setVolumes()
}

function stop() {
	for (let source of sources) {
		source.stop()
		source.disconnect()
	}
	sources = []
	gainNodes = {}
}

function setGuide(newGuide) {
	guide = newGuide
	setVolumes()
}

function setVolume(newVolume) {
	volume = newVolume
	setVolumes()
}

function setSystemVolume(newSystemVolume) {
	systemVolume = newSystemVolume
	setVolumes()
}

function setVolumes() {
	if (gainNodes.music) gainNodes.music.gain.value = guide?0:volume*systemVolume*hardVolume
	if (gainNodes.guide) gainNodes.guide.gain.value = guide?volume*systemVolume*hardVolume:0
}

let singleBuffers = {}
function playSingle(id) {
	if (!singleBuffers[id]) {
		let bufferLoader = new BufferLoader(audioContext, ['/audio/'+id+'.wav'], function(newBuffers) {
			singleBuffers[id] = newBuffers[0]
			go()
		})
		bufferLoader.load()
	}
	go()
	function go() {
		let source = audioContext.createBufferSource()
		source.buffer = singleBuffers[id]
		let gainNode = audioContext.createGain()
		source.connect(gainNode)
		gainNode.connect(audioContext.destination)
		source.start(0, 0)
	}
}

let Audio = {
	load: load,
	play: play,
	stop: stop,
	setGuide: setGuide,
	setVolume: setVolume,
	setSystemVolume: setSystemVolume,
	playSingle: playSingle
}

export default Audio
